export const USER_CHANNEL = { EMAIL: "email", WECHAT: "wechat" } as const;
export type USER_CHANNEL = (typeof USER_CHANNEL)[keyof typeof USER_CHANNEL];
export const USER_CHANNEL_NAME: ReadonlyMap<USER_CHANNEL, string> = new Map([
  [USER_CHANNEL.EMAIL, "邮箱注册"],
  [USER_CHANNEL.WECHAT, "微信用户"],
]);
